import { Injectable } from '@angular/core'
import { ComponentPortal } from '@angular/cdk/portal'
import { LoadingOverlayComponent } from './loading-overlay.component'
import { Overlay } from '@angular/cdk/overlay'

const portal = new ComponentPortal(LoadingOverlayComponent)

@Injectable({
  providedIn: 'root'
})
export class LoadingOverlay {
  private ref = this.overlay.create({
    positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    hasBackdrop: true,
    scrollStrategy: this.overlay.scrollStrategies.block(),
  })

  private delayedHide: number | null = null

  constructor(private overlay: Overlay) { }

  show(): void {
    if(this.delayedHide) {
      window.clearTimeout(this.delayedHide)
    }
    if(!this.ref.hasAttached()) {
      this.ref.attach(portal)
    }
  }

  hide(delay = 0): void {
    this.delayedHide = window.setTimeout(() => this.ref.detach(), Math.max(0, delay))
  }
}
